import React, { useState } from 'react'
import axios from 'axios'
import moment from 'moment'

import Btn from '../ui/Btn'
import VideoModal from '../ui/VideoModal'
import { posterUrl } from '../ui/videoSource'
import './challenges.css'

/*
 * ONE SUBMISSION, under review.
 *
 * POST admin/dashboard/publishusrchallenge { ChallengeID, UserID, IsPublished }
 * — untouched: same URL, same payload, same headers, and the same reading of
 * the answer (err==0 -> reload the queue and go back to it, otherwise show the
 * message the server sent).
 *
 * What changed is the reviewing, not the request. The old screen printed the
 * clip through a second player wired to a hard-coded streamlock URL that never
 * stripped a file extension; the tape now opens in the shared VideoModal via
 * videoSource, which walks the naming conventions the library actually holds.
 * window.confirm() and alert() are gone: the confirmation is a strip in the
 * page, and the server's message is shown inline instead of in a browser box.
 */

const IconPlay = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.2v13.6L19 12 8 5.2z" /></svg>
)

export default function ChallengeFormReview(props) {

  const item = props.item || {}

  const [isLoading,setIsLoading]=useState(false)
  const [confirming,setConfirming]=useState(false)
  const [note,setNote]=useState(null)
  const [playing,setPlaying]=useState(false)

  const name=[item.FirstName,item.LastName].filter(Boolean).join(' ').trim() || 'Άγνωστος χρήστης'
  const when=item.DateCreated ? moment(item.DateCreated) : null
  const poster=item.FileID ? posterUrl(item.FileID) : ''

const activate=(IsPublished)=>{

    setConfirming(false)
    setNote(null)
    setIsLoading(true)

    const obj={
      ChallengeID:props.item.ChallengeID,
      UserID:props.item.UserID,
      IsPublished:IsPublished
    }

      axios.post(process.env.REACT_APP_API_SERVER+'admin/dashboard/publishusrchallenge',obj,{
          headers: {
              'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
              }
          })
        .then(res=>{
          if (res.data.err==0){
              props.loadData()
             props.showForm(0,false)
          }else{
            setIsLoading(false)
            setNote({tone:'crit',text:res.data.msg})
          }


      }).catch(err=>{
        setIsLoading(false)
        setNote({tone:'crit',text:'Υπήρξε ένα πρόβλημα, παρακαλώ προσπαθήστε ξανά'})
      })
}

  return (
    <div className="chx-review">

      <div className="chx-review-side">
        <button
          type="button"
          className="chx-thumb"
          onClick={()=>setPlaying(true)}
          disabled={!item.FileID}
          title={item.FileID ? 'Προβολή βίντεο' : 'Χωρίς βίντεο'}
          aria-label={item.FileID ? 'Προβολή βίντεο — '+name : 'Χωρίς βίντεο'}
        >
          {poster
            ? <img src={poster} alt="" decoding="async"/>
            : <span className="chx-thumb-blank">Χωρίς βίντεο</span>}
          {item.FileID && <span className="chx-play" aria-hidden="true"><IconPlay/></span>}
        </button>

        <Btn onClick={()=>setPlaying(true)} disabled={!item.FileID}>
          <IconPlay/>
          Προβολή βίντεο
        </Btn>
      </div>

      <div className="chx-review-main">

        <div>
          <h2 className="chx-headline">{item.Title}</h2>

          <ul className="chx-facts">
            <li className="chx-fact">
              <span className="chx-fact-label">Χρήστης</span>
              <span className="chx-fact-value">{name}</span>
            </li>
            <li className="chx-fact">
              <span className="chx-fact-label">Δημοσίευση</span>
              <span className="chx-fact-value">
                {when && when.isValid() ? when.format('DD/MM/YYYY HH:mm') : '—'}
              </span>
            </li>
            <li className="chx-fact">
              <span className="chx-fact-label">Βίντεο</span>
              <span className="chx-fact-value mono">{item.FileID || '—'}</span>
            </li>
          </ul>
        </div>

        {note && (
          <div className={note.tone==='crit' ? 'chx-note chx-note-crit' : 'chx-note chx-note-good'} role="status">
            <span className="chx-note-text">{note.text}</span>
          </div>
        )}

        {confirming && (
          <div className="chx-confirm" role="alertdialog" aria-label="Επιβεβαίωση δημοσίευσης">
            <span className="chx-confirm-text">ΔΗΜΟΣΙΕΥΣΗ CHALLENGE. Σίγουρα;</span>
            <span className="chx-confirm-act">
              <Btn onClick={()=>setConfirming(false)}>Άκυρο</Btn>
              <Btn variant="accent" onClick={()=>activate(1)}>Ναι, δημοσίευση</Btn>
            </span>
          </div>
        )}

        <div className="chx-actions">
          <Btn onClick={()=>{props.showForm(0,false)}}>Άκυρο</Btn>
          <Btn
            variant="accent"
            onClick={()=>{setConfirming(true)}}
            disabled={isLoading || confirming}
          >
            {isLoading ? 'Δημοσίευση…' : 'PUBLISH'}
          </Btn>
        </div>

      </div>

      {playing && item.FileID && (
        <VideoModal
          items={[{ fileId:item.FileID, name:name, subtitle:item.Title }]}
          index={0}
          title={item.Title}
          onIndex={()=>{}}
          onClose={()=>setPlaying(false)}
        />
      )}

    </div>
  )
}
